import React from "react";
import MuiSkeleton from "@mui/material/Skeleton";
import PropTypes from "prop-types";

const Skeleton = (props) => {
  return <MuiSkeleton {...props} animation="wave" />;
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf(["text", "rectangular", "rounded", "circular"]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Skeleton;
